import gql from "graphql-tag"

const query = gql`
  query GlobalTenant($subdomain: String!) {
    globalTenant(subdomain: $subdomain) {
      subdomain
      tenantId
      region
    }
  }
`

export const toString = query.loc.source.body

export default query
